import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MDBCol, MDBRow } from "mdbreact";
import { Input, Label } from "abs-ui-components";
import {
	INPUT_STEP_VALUE,
	preventScientificNotation,
	roundOff,
} from "../../../services/utilities";

const CorrectionsElectricPowerFormGroup = (props) => {
	const { control, setValue, trigger } = useFormContext();

	const handleSfocBlur = async (field, value) => {
		if (!isNaN(value)) {
			if (+value > 0) {
				setValue(field, roundOff(value));
			}
		} else {
			return null;
		}
		await trigger(field);
	};

	return (
		<>
			<div className="container-fluid p-0 m-0">
				<MDBRow>
					<MDBCol md="12" className="mt-3">
						<Label
							bold
							name="SFOC for Reefer (g/kWh)"
							className="mb-1"
						/>
						<Controller
							name="vesselAttributes.sfocReefer"
							control={control}
							rules={
								props?.regulations?.trim() !== "EUMRV" &&
								props?.regulations?.trim() !== "UKMRV" &&
								props?.regulations?.trim() !== "DCS"
									? {
											min: {
												value: Number.EPSILON,
												message:
													"Please enter a value greater than zero.",
											},
									  }
									: {}
							}
							defaultValue={
								props.vesselMstId
									? props.vesselData?.SfocReefer === 0 ||
									  props.vesselData?.SfocReefer === null
										? ""
										: roundOff(props.vesselData?.SfocReefer)
									: ""
							}
							render={({ field }) => (
								<Input
									name={field.name}

									id="vessel_sfoc"
									autoFocus={false}
									value={field.value}
									onChange={field.onChange}
									type="number"
									className="input-height"
									step={INPUT_STEP_VALUE}
									onBlur={(e) =>
										handleSfocBlur(field.name, field.value)
									}
									onKeyDown={(e) => {
										preventScientificNotation(e);
										// Prevent up and down arrow keys
										if (
											e.key === "ArrowUp" ||
											e.key === "ArrowDown"
										) {
											e.preventDefault();
										}
									}}
									onWheel={(e) => e.target.blur()}
									maxLength={7}
									onInput={(e) => {
										if (e.target.value.length > 7) {
											e.target.value =
												e.target.value.slice(0, 7);
										}
									}}
									disabled={
										!props.isEnrollVessel &&
										props.vesselMstId &&
										(props?.regulations?.trim() ===
											"EUMRV" ||
											"UKMRV" ||
											"DCS")
									}
								/>
							)}
						/>
					</MDBCol>
					<MDBCol md="12" className="mt-3">
						<Label
							bold
							name="Fuel Code for Reefer"
							className="mb-1"
						/>
						<Controller
							name="vesselAttributes.fuelTypeIdKey"
							control={control}
							defaultValue={
								props?.vesselMstId
									? props.vesselData?.FuelTypeIdKey
									: null
							}
							render={({ field }) => (
								<>
									<Input
										name={field.name}
										id="vessel_fuelidkey"
										autoFocus={false}
										value={field.value}
										onChange={(e) => field.onChange(e)}
										className="input-height field-to-uppercase"
										required
										maxLength={60}
										disabled={
											!props.isEnrollVessel &&
											props.vesselMstId &&
											(props?.regulations?.trim() ===
												"EUMRV" ||
												"UKMRV" ||
												"DCS")
										}
									/>
								</>
							)}
						/>
					</MDBCol>
				</MDBRow>
			</div>
		</>
	);
};

export default CorrectionsElectricPowerFormGroup;
